import script from "./Stores.vue?vue&type=script&setup=true&lang=js"
export * from "./Stores.vue?vue&type=script&setup=true&lang=js"

export default script